<template>
  <div
    class="w-56 h-56 p-2 flex flex-col items-center justify-center cursor-default text-center"
    :class="{
      'order-1': wonder.ownerCapital === 1,
      'order-2': wonder.ownerCapital !== 1,
    }"
  >
    <div class="flex flex-col items-center gap-3 relative justify-center w-full h-full rounded border border-gray-300">
      <img
        :src="require(`@/assets/images/wonder/${wonder.icon}`)"
        alt=""
        class="w-12 h-12"
      >
      <span class="leading-none uppercase font-medium">
        {{ wonder.name }}
      </span>
      <KindName
        :kind="wonder.kind"
        :kindMultiplier="wonder.kindMultiplier"
      />
      <AlliedCultureCrest
        class="absolute left-1/2 top-1/2 -translate-x-10 -translate-y-14"
        :wonder="wonder"
        size="large"
      />
    </div>
  </div>
</template>

<script>
import AlliedCultureCrest from '@/components/Wonders/AlliedCultureCrest.vue';
import KindName from '@/components/Wonders/KindName.vue';

export default {
  components: {KindName, AlliedCultureCrest},
  props: {
    wonder: {
      type: Object,
      required: true
    }
  }
};
</script>
